// libraries
import { Typography } from '@interstate/components/Typography';
import { kebabCase } from '@makemydeal/dr-common-utils';

// styles
import { StyledField } from './PurchaseHistorySection.style';

export type PurchaseHistoryFieldUIProps = {
    label: string;
    value: string;
};

export const PurchaseHistoryFieldUI = ({ label, value }: PurchaseHistoryFieldUIProps) => (
    <StyledField data-testid={`purchase-history-field-${kebabCase(label)}`}>
        <Typography tag="span" variant="body-xs" color="sem.color.on-surface.muted">
            {label}
        </Typography>
        <Typography tag="span" variant="body-xs" color="sem.color.on-surface.default">
            {value}
        </Typography>
    </StyledField>
);

export default PurchaseHistoryFieldUI;
